"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleHeaderCms = void 0;
var ScheduleHeaderCms = /** @class */ (function () {
    function ScheduleHeaderCms() {
        this.headerText = 'Appointment preference';
        this.internet = 'Internet ';
        this.directv = 'DIRECTV ';
        this.setupInstallationLabel = "Set up your installation";
    }
    return ScheduleHeaderCms;
}());
exports.ScheduleHeaderCms = ScheduleHeaderCms;
//# sourceMappingURL=ScheduleHeader.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/ScheduleHeader/ScheduleHeader.cms.js
// module id = 967
// module chunks = 8